import React, { useState } from "react";
import "../static/css/Intro.css";
import { Link } from "react-router-dom";
import intro_image from "../static/img/Intro.jpeg"

function Intro() {

    return (
        <>
            <div className="Intro-container-1">
                <div className="Intro-box-1">
                    <div className="details-intro">
                        <h4>SPP Insolvency Professionals LLP: Multidisciplinary IPE with Pan-South India Reach</h4>
                        <p>SPP Insolvency Professionals LLP is an IBBI-registered Insolvency Professional Entity (IPE) headquartered in Coimbatore, Tamil Nadu. Formed in 2022 through the demerger of SPP & Co.'s IBC wing, the firm brings experience from over 40 insolvency and liquidation cases across 20+ sectors. It is led by a multidisciplinary team of Chartered Accountants, Company Secretaries, retired bankers, and legal experts, offering end-to-end services in CIRP, liquidation, forensic audits, and restructuring. The firm is empanelled with major public sector banks and operates across Tamil Nadu, Kerala, Andhra Pradesh, and Karnataka.</p>
                        <Link to="/team"><button>About Us <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.175 9.71997H0V7.71997H12.175L6.575 2.11997L8 0.719971L16 8.71997L8 16.72L6.575 15.32L12.175 9.71997Z" fill="#F8F8F9" />
                        </svg></button></Link>
                    </div>
                    <div className="image">
                        <img src={intro_image} alt="intro image" />
                    </div>
                </div>
            </div>

            {/* SPP & CO Advantage Section */}
            <div className="Intro-container-1" style={{ paddingTop: '2rem', paddingBottom: '3rem' }}>
                <div className="Intro-box-1" style={{ flexDirection: 'column' }}>
                    <h3 style={{
                        fontSize: '2rem',
                        fontWeight: 'bold',
                        marginBottom: '1.5rem',
                        color: '#001f4b',
                        textAlign: 'center'
                    }}>
                        SPP & CO Advantage
                    </h3>
                    <div style={{
                        maxWidth: '900px',
                        margin: '0 auto',
                        fontSize: '1.1rem',
                        lineHeight: '1.8',
                        textAlign: 'justify'
                    }}>
                        <p>
                            <strong>Why Partner with us?</strong> - SPP Insolvency Professionals LLP offers end-to-end insolvency and restructuring services across CIRP, liquidation, individual insolvency, forensic audits, and resolution planning. With 40+ IBC mandates in 20+ sectors—including landmark cases involving government entities—we specialize in revival-focused outcomes, with most cases resolved through approved resolution plans. Backed by a multidisciplinary team and empanelment with major banks, we ensure compliant execution, investor coordination, and strategic recovery.
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Intro;